import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@fortawesome/fontawesome-free/svgs/solid/sun.svg'
import _imports_1 from '@fortawesome/fontawesome-free/svgs/solid/star.svg'


const _hoisted_1 = { class: "weather-widget__loading" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "icon icon_rotate",
  alt: "Sun spinning"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  class: "icon icon_rotate",
  alt: "Star spinning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isDayTime)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3))
  ]))
}